var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.087,
    height: 102.145,
    viewBox: "0 0 102.087 102.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16491",
    "data-name": "Group 16491",
    transform: "translate(443 2276)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_834",
    "data-name": "Ellipse 834",
    cx: 51.043,
    cy: 51.043,
    r: 51.043,
    transform: "translate(-443 -2276)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5518",
    "data-name": "Path 5518",
    d: "M146.1,150.135c5.145,18.679,3.279,34.453-3.9,40.38-23.659,15.6-44.164-1.4-44.074-1.163.158.189,25.965,30.869,26.14,30.822A51.161,51.161,0,0,0,169.7,186.728C169.493,186.667,146.122,150.063,146.1,150.135Z",
    transform: "translate(-513.607 -2394.028)",
    fill: "#ad1409"
  }), /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(-422.972 -2255.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13047",
    "data-name": "Group 13047",
    transform: "translate(0 0.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000026123480862262695870000014710365773972803006_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-2",
    "data-name": "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5788",
    "data-name": "Path 5788",
    d: "M31.005,62.047A31.014,31.014,0,0,1,9.079,9.107l1.281,1.281L9.079,9.107a31.018,31.018,0,1,1,21.926,52.94Zm0-58.393a27.379,27.379,0,1,0,19.361,8.02,27.379,27.379,0,0,0-19.361-8.02Z",
    transform: "translate(0 -0.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5789",
    "data-name": "Path 5789",
    d: "M157.5,179.869a1.818,1.818,0,0,1-1.286-3.1l20.645-20.645a1.818,1.818,0,0,1,2.615,2.526l-.045.045-20.645,20.645A1.817,1.817,0,0,1,157.5,179.869Z",
    transform: "translate(-136.814 -136.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5790",
    "data-name": "Path 5790",
    d: "M177.982,179.869a1.817,1.817,0,0,1-1.286-.533l-20.645-20.645a1.818,1.818,0,1,1,2.525-2.615l.045.045,20.645,20.645a1.818,1.818,0,0,1-1.284,3.1Z",
    transform: "translate(-136.654 -136.717)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.53fb8e6c43ffc8efaa00af909d31b5f5.svg";
export { ForwardRef as ReactComponent };